import Styles from './NotificationItem.module.scss'
import { DocEmoji } from 'components/DocEmoji/DocEmoji'
import { NotificationArticle as NotificationArticleType } from './types'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  article: NotificationArticleType
}

export const NotificationArticle = ({ article }: Props) => {
  return (
    <div className={Styles.file}>
      {article?.channel_emoji ? (
        <div className={Styles.emoji}>
          <ChannelIcon channel={article.channel_emoji} />
        </div>
      ) : (
        <DocEmoji emoji={article.header_emoji || null} className={Styles.emoji} />
      )}
      <Text lineClamp={1} variant="placeholder" color="var(--dark-80)">
        {article.title}
      </Text>
    </div>
  )
}
